import { Box, Typography } from '@mui/material';
import { alpha, type Theme } from '@mui/material/styles';
import type { ProductRegistryEnvironment } from '@/types/productRegistry';

interface EnvironmentChipProps {
  environment: ProductRegistryEnvironment;
  label: string;
}

function resolveEnvironmentTone(
  theme: Theme,
  environment: ProductRegistryEnvironment,
): string {
  if (environment === 'production') {
    return theme.palette.text.primary;
  }

  if (environment === 'stage') {
    return theme.palette.info.main;
  }

  if (environment === 'sandbox') {
    return theme.palette.warning.main;
  }

  return theme.palette.primary.main;
}

export function EnvironmentChip({ environment, label }: EnvironmentChipProps) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        px: 1,
        py: 0.25,
        borderRadius: 1,
        bgcolor: (theme) => {
          const tone = resolveEnvironmentTone(theme, environment);
          return alpha(tone, theme.palette.mode === 'dark' ? 0.24 : 0.12);
        },
      }}
    >
      <Typography
        component="span"
        variant="caption"
        sx={{ color: (theme) => resolveEnvironmentTone(theme, environment) }}
      >
        {label}
      </Typography>
    </Box>
  );
}
